import { ChangeEvent, PureComponent } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Input } from '../../../components/common';
import { EInputKind } from '../../../components/common/Input/Input';
import { changeCaptchaValue, requestCaptcha } from '../captchaActions';
import { ICaptchaState } from '../captchaReducer';
import { CaptchaFormStyled } from './styled/CaptchaFormStyled';

export interface ICaptchaTranslation {
    label: string;
    img_alt?: string;
}

export interface ICaptchaProps extends ICaptchaState {
    changeCaptchaValue: (v: string) => void;
    requestCaptcha: (captchaTime: number) => void;
    translation: ICaptchaTranslation;
}


export class Captcha extends PureComponent<ICaptchaProps> {
    componentDidMount(): void {
        this.requestCaptcha();
    }

    requestCaptcha = () => {
        this.props.requestCaptcha(new Date().valueOf());
    };

    onChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.props.changeCaptchaValue(e.target.value);
    };
    render() {
        const { isValid, captchaImage, translation } = this.props;
        return captchaImage ? <CaptchaFormStyled>
            <img
                alt={translation.img_alt || 'Captcha code here'}
                className="captcha-container__image"
                id="captcha"
                src={captchaImage}
            />
            <Input
                className="captcha-container__input"
                kind={isValid ? EInputKind.normal : EInputKind.error}
                label={translation.label}
                onChange={this.onChange}
            />
        </CaptchaFormStyled> : '';
    }
}

const mapStateToProps = ({ captcha }: { captcha: ICaptchaState }) => ({
    ...captcha,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeCaptchaValue: (value: string) => dispatch(changeCaptchaValue({ value })),
    requestCaptcha: (captchaTime: number) => dispatch(requestCaptcha({ captchaTime })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Captcha);
